import { render, staticRenderFns } from "./ListSuveyArticle.vue?vue&type=template&id=487f3957"
import script from "./ListSuveyArticle.ts?vue&type=script&lang=ts&external"
export * from "./ListSuveyArticle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports